import { QuestionOption, QuestionOptionWithValues, QuestionType, Survey } from '@core/types';
import { useTranslation } from 'react-i18next';

export const useDefaultSurvey = (): Survey => {
    const { t } = useTranslation();

    const createRangeOptions = (start: number, end: number): QuestionOption[] => {
        const options: QuestionOptionWithValues[] = [];
        for (let i = start; i <= end; i++) {
            options.push({ optionId: '00000000-0000-0000-0000-' + i.toString().padStart(12, '0'), value: i, text: i.toString() });
        }
        return options;
    };

    const createYesNoOptions = (): QuestionOption[] => {
        const options = createRangeOptions(1, 2);
        options[0].text = t('DefaultSurvey.Answer.Yes');
        options[1].text = t('DefaultSurvey.Answer.No');
        return options;
    };

    return {
        enabled: false,
        required: false,
        isValid: true,
        useDefault: false,
        title: t('DefaultSurvey.Title'),
        intro: t('DefaultSurvey.Intro'),
        outro: t('DefaultSurvey.Outro'),
        questions: [
            {
                questionId: '00000000-0000-0000-0000-000000000001',
                questionText: t('DefaultSurvey.Question.OverallRating'),
                questionType: QuestionType.SingleChoice,
                options: createRangeOptions(1, 10),
                hasOtherOption: false,
                required: false
            },
            {
                questionId: '00000000-0000-0000-0000-000000000002',
                questionText: t('DefaultSurvey.Question.SpeakerRating'),
                questionType: QuestionType.SingleChoice,
                options: createRangeOptions(1, 10),
                hasOtherOption: false,
                required: false
            },
            {
                questionId: '00000000-0000-0000-0000-000000000003',
                questionText: t('DefaultSurvey.Question.ContentRating'),
                questionType: QuestionType.SingleChoice,
                options: createRangeOptions(1, 10),
                hasOtherOption: false,
                required: false
            },
            {
                questionId: '00000000-0000-0000-0000-000000000004',
                questionText: t('DefaultSurvey.Question.QuestionRating'),
                questionType: QuestionType.SingleChoice,
                options: createYesNoOptions(),
                hasOtherOption: true,
                otherOptionText: t('DefaultSurvey.Answer.Other'),
                required: false
            },
            {
                questionId: '00000000-0000-0000-0000-000000000005',
                questionText: t('DefaultSurvey.Question.WouldRecommend'),
                questionType: QuestionType.SingleChoice,
                options: createYesNoOptions(),
                hasOtherOption: false,
                required: false
            },
            {
                questionId: '00000000-0000-0000-0000-000000000006',
                questionText: t('DefaultSurvey.Question.OpenQuestion'),
                questionType: QuestionType.Open,
                options: [],
                hasOtherOption: false,
                required: false
            }
        ]
    };
};
